// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';
import { AiOutlineClockCircle } from 'react-icons/ai';
import {
  convertSaleStatusToClassName,
  convertSaleStatusToColor,
} from '../../../../utils/convertSaleStatus';

import './index.scss';
const maxShowTotalBuy = 9999;
const showTotalBuy = '9999+';

function RecommendLotteryItem({
  collection,
  onClick,
  isShowTime = false,
  isRecommendLottery = false,
}) {
  return (
    <div className="wrap-card-recommend-lottery">
      <div className="card-recommend-lottery card" onClick={onClick}>
        <div className="card-img-top">
          <div>
            <img src={isRecommendLottery ? collection.image : collection.image.image_url} />
          </div>
        </div>
        <div className="card-body">
          <div className="d-flex">
            <div
              style={{
                backgroundImage: `url(${convertSaleStatusToClassName(collection.sale_status)})`,
                backgroundSize: '100% 100%',
              }}
              className="sale-status"
            ></div>
            <div className="d-flex">
              <div className="card-end-date-icon">
                <AiOutlineClockCircle />
              </div>
              <div className="AOTFShinMaruGoPro card-end-date">{collection.end_date}</div>
            </div>
          </div>
          <div className="card-title mb-0 AOTFShinMaruGoPro">
            {' '}
            {collection.name.length > 55
              ? collection.name.substring(0, 55) + '...'
              : collection.name}{' '}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecommendLotteryItem;
